import React from "react";
import { useRef, useState, useEffect } from "react";
import { Box, Flex, IconButton, Heading } from "@chakra-ui/react";
import { FaPlay, FaPause } from "react-icons/fa";
import promo from "../../assets/video/PromoVideo.mp4";
import Animated from "./AnimatedSection";

const VideoSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // useEffect(() => {
  //   return () => {
  //     if (videoRef.current) {
  //       videoRef.current.pause();
  //       setIsPlaying(false);
  //     }
  //   };
  // }, []);

  return (
    <Flex
      id="video"
      mb={{ base: 6, lg: 12 }}
      flexDirection={"column"}
      mt={{ base: 8, lg: 0 }}
      position="relative"
    >
      <Box w="90%" mb={{ base: 2, lg: 6 }} mx="auto">
        <Animated>
          <Heading fontSize={{ base: "28px", lg: "72px" }} color="brand.200">
            2025{"  "}
            <span style={{ color: "rgba(170, 87, 225, 1)" }}>Promo Video</span>
          </Heading>
        </Animated>
      </Box>
      <Box
        mx="auto"
        width="90%"
        borderRadius={{ base: "24px", lg: "42px" }}
        overflow="hidden"
        h="100%"
        position="relative"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          zIndex="1"
        />

        <video
          ref={videoRef}
          width="100%"
          autoPlay
          loop
          playsInline
          style={{
            borderRadius: "inherit",

            position: "relative",
            zIndex: 0,
          }}
        >
          <source src={promo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <IconButton
          aria-label="Play/Pause Video"
          icon={isPlaying ? <FaPause /> : <FaPlay />}
          onClick={togglePlayPause}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          zIndex="3"
          bg="whiteAlpha.800"
          color="black"
          _hover={{ bg: "whiteAlpha.900" }}
          size="lg"
          borderRadius="full"
        />
      </Box>
    </Flex>
  );
};

export default VideoSection;
